import "./LeagueRow.css";

function leagueStatus(league) {
  if (league.disabled_by_user) return "disabled";
  if (league.active) return "active";
  return "offSeason";
}

const LABEL = {
  active: "Active",
  offSeason: "Off-season",
  disabled: "Disabled",
};

const PLATFORM_LABEL = {
  espn: "ESPN",
  sleeper: "Sleeper",
};

/** One row in the dashboard's league list: identity, status, and the
 * manage entry point. Receiving count only counts members who have a
 * subscribed email on file — matching who the Tuesday cron actually mails. */
function LeagueRow({ league, onManage }) {
  const status = leagueStatus(league);
  const members = league.league_members || [];
  const memberCount = members.length;
  const receivingCount = members.filter(
    (lm) => lm.members?.email && lm.members?.subscribed
  ).length;
  const platformLabel = PLATFORM_LABEL[league.service] ?? null;

  return (
    <div
      className={`booth-league-row ${
        status === "disabled" ? "booth-league-row--disabled" : ""
      }`}
    >
      <div className="booth-league-row-identity">
        <h3 className="booth-league-row-name tname">{league.name}</h3>
        {platformLabel && (
          <span className="booth-league-row-platform">{platformLabel}</span>
        )}
      </div>

      <div className="booth-league-row-status">
        <span className={`booth-league-status booth-league-status--${status}`}>
          <span className="booth-league-status-dot" aria-hidden="true" />
          {LABEL[status]}
        </span>
        {status === "active" && (
          <span className="booth-league-row-next">
            Next dispatch Tuesday, 5:00 AM
          </span>
        )}
      </div>

      <div className="booth-league-row-meta">
        <span className="booth-league-row-members">
          {receivingCount} of {memberCount} receiving
        </span>
        <button
          type="button"
          className="booth-league-row-manage"
          onClick={() => onManage(league)}
        >
          Manage
        </button>
      </div>
    </div>
  );
}

export default LeagueRow;
